"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.PropertyCancellationPolicyUpdateDto = void 0;
var class_validator_1 = require("class-validator");
var class_transformer_1 = require("class-transformer");
var CancellationWindow = (function () {
    function CancellationWindow() {
    }
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsIn(['HOUR', 'DAY', 'WEEK', 'MONTH']),
        __metadata("design:type", String)
    ], CancellationWindow.prototype, "timeUnit");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], CancellationWindow.prototype, "value");
    return CancellationWindow;
}());
var Deduction = (function () {
    function Deduction() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['NONE', 'NIGHT', 'PERCENT', 'FLAT_RATE']),
        __metadata("design:type", String)
    ], Deduction.prototype, "type");
    return Deduction;
}());
var DeductionNone = (function (_super) {
    __extends(DeductionNone, _super);
    function DeductionNone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['NONE']),
        __metadata("design:type", String)
    ], DeductionNone.prototype, "type");
    return DeductionNone;
}(Deduction));
var DeductionNightsPercent = (function (_super) {
    __extends(DeductionNightsPercent, _super);
    function DeductionNightsPercent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['NIGHT', 'PERCENT']),
        __metadata("design:type", String)
    ], DeductionNightsPercent.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DeductionNightsPercent.prototype, "value");
    return DeductionNightsPercent;
}(Deduction));
var DeductionFlatRate = (function (_super) {
    __extends(DeductionFlatRate, _super);
    function DeductionFlatRate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['FLAT_RATE']),
        __metadata("design:type", String)
    ], DeductionFlatRate.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DeductionFlatRate.prototype, "value");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DeductionFlatRate.prototype, "currency");
    return DeductionFlatRate;
}(Deduction));
var PropertyCancellationPolicyUpdateDto = (function () {
    function PropertyCancellationPolicyUpdateDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], PropertyCancellationPolicyUpdateDto.prototype, "name");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], PropertyCancellationPolicyUpdateDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PropertyCancellationPolicyUpdateDto.prototype, "isNonRefundable");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (o) { return !o.isNonRefundable; }),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return CancellationWindow; }),
        __metadata("design:type", CancellationWindow)
    ], PropertyCancellationPolicyUpdateDto.prototype, "cancellationWindow");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (o) { return !o.isNonRefundable; }),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Deduction; }, {
            discriminator: {
                property: 'type',
                subTypes: [
                    { value: DeductionNone, name: 'NONE' },
                    { value: DeductionNightsPercent, name: 'NIGHT' },
                    { value: DeductionNightsPercent, name: 'PERCENT' },
                    { value: DeductionFlatRate, name: 'FLAT_RATE' },
                ]
            },
            keepDiscriminatorProperty: true
        }),
        __metadata("design:type", Object)
    ], PropertyCancellationPolicyUpdateDto.prototype, "insideWindowDeduction");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (o) { return !o.isNonRefundable; }),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Deduction; }, {
            discriminator: {
                property: 'type',
                subTypes: [
                    { value: DeductionNone, name: 'NONE' },
                    { value: DeductionNightsPercent, name: 'NIGHT' },
                    { value: DeductionNightsPercent, name: 'PERCENT' },
                    { value: DeductionFlatRate, name: 'FLAT_RATE' },
                ]
            },
            keepDiscriminatorProperty: true
        }),
        __metadata("design:type", Object)
    ], PropertyCancellationPolicyUpdateDto.prototype, "outsideWindowDeduction");
    return PropertyCancellationPolicyUpdateDto;
}());
exports.PropertyCancellationPolicyUpdateDto = PropertyCancellationPolicyUpdateDto;
//# sourceMappingURL=property-cancellation-policy-update.dto.js.map